import OperationsSeatedReport from "../../components/Operations/SeatedReport/OperationsSeatedReport";

const OperationsSeatedReportPage = () => {
  return <OperationsSeatedReport />;
};

export default OperationsSeatedReportPage;
